import React from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  bytesToSize,
} from '../../../helpers';

import { WysiwygField } from '../../../components';

import './style.scss';

const Downloads = ({ id, entity, wide }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  return (
    <Container id={id} className="Paragraph Downloads">
      <div className="Downloads__inner">
        <div className="row">
          <div className={`col-12 ${!wide && `col-lg-8 offset-lg-2`}`}>
            {title && (
              <h3 className="Downloads__title">{title}</h3>
            )}

            {body && (
              <WysiwygField
                property="schema:text"
                className="Downloads__body"
                html={body} />
            )}

            {entity.get('field_media_items', Immutable.List()).size ? (
              <ul className="Downloads__list">
                {entity.get('field_media_items').map((item) => {
                  const title = item.get('title');
                  const description = item.getIn(['entity', 'field_caption', 0, 'value'], null);
                  const fileSize = item.get('file_size', 0);
                  const filesizeLabel = fileSize ? bytesToSize(fileSize) : '';
                  const mimetype = item.get('mime_type', 'unknown/unknown');
                  const [mime, type] = mimetype.split('/');
                  const classes = classNames('Downloads__item', `Downloads__item--${mime}`, `Downloads__item--${type}`);

                  return (
                    <li className={classes} key={item.get('target_uuid')}>
                      <div className="Downloads__item__icon icon-before icon-download icon-variant-2" />
                      <div className="Downloads__item__content">
                        <a target="_blank" href={item.get('source')} rel="noreferrer">{description || title}</a><br />
                        <div className="Downloads__item__metadata">
                          <div className="Downloads__item__metadata__filesize">{filesizeLabel}</div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Downloads;
